import { render, staticRenderFns } from "./PxModal.vue?vue&type=template&id=a9e41260&"
import script from "./PxModal.vue?vue&type=script&lang=js&"
export * from "./PxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports